import { render, staticRenderFns, recyclableRender, components } from "./u-line-progress.vue?vue&type=template&id=02285945&scoped=true&"
var renderjs
import script from "./u-line-progress.vue?vue&type=script&lang=js&"
export * from "./u-line-progress.vue?vue&type=script&lang=js&"
import style0 from "./u-line-progress.vue?vue&type=style&index=0&id=02285945&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02285945",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-line-progress/u-line-progress.vue"
export default component.exports